import type { WorkOrderDetails } from '#/graphql/types';
import type { FormItem } from '#/common/components/Form';
import allFields from '#/modules/workOrder/utils/fields';

const fields: FormItem<WorkOrderDetails>[] = [
  {
    colCount: 3,
    cssClass: 'tmm-section-no-background',
    caption: 'Work Order Details',
    items: [
      allFields.tenantId,
      { ...allFields.findingId, colSpan: 1 },
      { ...allFields.asset, colSpan: 1 },
    ],
  },
  {
    colCount: 6,
    cssClass: 'tmm-section tmm-section-no-caption',
    items: [
      {
        ...allFields.title,
        colSpan: 6,
      },
      {
        ...allFields.state,
        colSpan: 2,
      },
      {
        ...allFields.priority,
        colSpan: 2,
      },
      {
        ...allFields.impact,
        colSpan: 2,
      },
      {
        ...allFields.category,
        colSpan: 4,
      },
      {
        ...allFields.assignedTo,
        colSpan: 2,
      },
      {
        ...allFields.description,
        colSpan: 6,
      },
    ],
  },

  {
    colCount: 3,
    cssClass: 'tmm-section',
    caption: 'Schedule',
    items: [
      { ...allFields.plannedStartDate, colSpan: 1 },
      { ...allFields.plannedEndDate, colSpan: 1 },
      { ...allFields.dueDate, colSpan: 1 },
      { ...allFields.startDate, colSpan: 1 },
      { ...allFields.endDate, colSpan: 1 },
      { ...allFields.duration, colSpan: 1 },
    ],
  },

  {
    colCount: 4,
    cssClass: 'tmm-section',
    caption: 'Resolution',
    items: [
      allFields.closedAt,
      allFields.closedBy,
      allFields.actualCostValue,
      allFields.actualEffort,
      { ...allFields.closedNotes, colSpan: 4 },
    ],
  },
];

export default fields;
